import $ from 'jquery'
import 'slick-carousel'

const textAnimation = 'carousel-blur-in'
// const textAnimation = '.carousel-fade-in'

document.addEventListener('DOMContentLoaded', () => {
	if(document.querySelector('.big-slider')){
		let textAnimationDivs = document.querySelectorAll('.js-carousel-text-animation')
		textAnimationDivs.forEach(i => i.classList.add(textAnimation, 'done'))

		$('.big-slider').slick({
			infinite: true,
			slidesToShow: 1, 
			autoplay: true,
			fade: true, 
			speed: 700, 
  			autoplaySpeed: 4000, 
  			arrows: true, 
  			dots: false, 
  			draggable: false,
  			swipeToSlide: false, 
  			prevArrow: false,
    		nextArrow: false,
			prevArrow: '<div class="big-slider_prev bg-grey"><div class="chevron chevron-left bg-black"></div></div>',
			nextArrow: '<div class="big-slider_next bg-grey"><div class="chevron bg-black"></div></div>'
		})
		$('.big-slider').on('beforeChange', function(event,slick, currentSlide, nextSlide){
			textAnimationDivs.forEach(i => i.classList.remove('done'))
			document.querySelectorAll(`[data-slick-index="${nextSlide}"] .js-carousel-text-animation`).forEach(i => i.classList.add('done'))
		})
		$('.big-slider').on('afterChange', function(event,slick, currentSlide){
			
		})
	}

	if(document.querySelector('.product_slider')){
		$('.product_slider').slick({
			infinite: true,
			slidesToShow: 1, 
			autoplay: true,
			fade: true, 
			speed: 700, 
  			autoplaySpeed: 8000, 
  			arrows: true, 
  			dots: false, 
  			draggable: false,
  			swipeToSlide: false, 
  			prevArrow: false,
    		nextArrow: false,
			prevArrow: '<div class="big-slider_prev bg-grey"><div class="chevron chevron-left bg-black"></div></div>',
			nextArrow: '<div class="big-slider_next bg-grey"><div class="chevron bg-black"></div></div>',
			asNavfor: '.product_slider_nav',
		})
		$('.product_slider').on('afterChange', function(event, info, c){
			document.querySelectorAll('.product_slider_nav_item').forEach(i => {i.classList.remove('is-active')})
			document.querySelectorAll('.product_slider_nav_item')[c].classList.add('is-active')
		})
		document.querySelectorAll('.product_slider_nav_item').forEach(i => {
			i.addEventListener('click', (e) => {
				$('.product_slider').slick('slickGoTo', parseInt(e.currentTarget.getAttribute('data-index')))
			})
		})
	}	
})